export default (params) => ({
  trigger: {
    name: 'reviews.write_review',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'page',
          'panel',
        ],
      },
    },
    event: {
      name: 'write_review',
    },
    nonInt: false,
  },
});
